import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ShiftNames, UserPermission } from 'packages/workspace/modules/algebra/constants';
import { Can } from 'packages/workspace/modules/helpers/contexts/abilities';
import useInternalOnCalls from 'packages/workspace/services/hooks/useInternalOnCalls';
import useAbilitiesStore from 'packages/workspace/services/store/abilities-store';
import { SyntheticEvent, useEffect, useState } from 'react';
import { MdContactPhone } from 'react-icons/md';
import PhoneComponent from './PhoneComponent';
import { InternalOnCallText } from './InternalOnCallText';

type InternalOnCallProps = {
  open: boolean;
  onClose: () => void;
};

const InternalOnCall: React.FC<InternalOnCallProps> = ({ open, onClose }) => {
  const { ability } = useAbilitiesStore();
  const [callInitiated, setCallInitiated] = useState<boolean>(false);
  const { data: internalOnCallQuery, isSuccess, isError } = useInternalOnCalls(open && ability.can(UserPermission.ONCALL, ShiftNames.USER), 'internal');

  useEffect(() => {
    if (!open) {
      setCallInitiated(false);
    }
  }, [open]);
  return (
    <>
      <Can I={UserPermission.ONCALL} a={ShiftNames.USER}>
        <Dialog
          fullWidth
          maxWidth={'sm'}
          open={open}
          onClose={(e: SyntheticEvent) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
        >
          <DialogTitle>Connect To On Call Shift Manager</DialogTitle>
          <DialogContent className="model-center-design">
            <DialogContentText>
              <InternalOnCallText />
            </DialogContentText>

            <Box
              component="span"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                m: 'auto',
                width: 'fit-content',
              }}
            >
              {isSuccess && internalOnCallQuery && !callInitiated && (
                <>
                  <Button className="mt-5" color="primary" variant="contained" size="large" onClick={() => setCallInitiated(true)}>
                    Connect
                  </Button>
                </>
              )}
              {callInitiated && internalOnCallQuery && (
                <PhoneComponent
                  call_message="You are now connecting with the On Call Shift Manager"
                  call_complete_message="Call with On Call Shift Manager is now complete, You can now close this window."
                  client_phone={internalOnCallQuery.phone}
                  force_disconnect={false}
                  token={internalOnCallQuery.token}
                  phone={internalOnCallQuery.phone}
                  additionalParams={{ action: 'internal-oncall' }}
                />
              )}
              {isError && <span>Something Went Wrong, Please Close this and try again</span>}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <MdContactPhone className="mr-1 text-base" />
        <span className="text-xs">On Call</span>
      </Can>
    </>
  );
};

export default InternalOnCall;
